import React from "react";
import Header from "../mainpagecomponents/Header";
import HeroSection from "../mainpagecomponents/HeroSection";
import PurposeSection from "../mainpagecomponents/PurposeSection";
import DOKLevelsSection from "../mainpagecomponents/DOKLevelsSection";
import ProficiencySection from "../mainpagecomponents/ProficiencySection";
import FeaturesCarousel from "../mainpagecomponents/FeaturesCarousel";
import TestimonialsSection from "../mainpagecomponents/TestimonialsSection";
import ContactSection from "../mainpagecomponents/ContactSection";
import Footer from "../mainpagecomponents/Footer";

const MainPage = () => {
    return (
        <div className="min-h-screen bg-cream">
            <Header />
            <main>
                <HeroSection />
                <PurposeSection />
                <DOKLevelsSection />
                <ProficiencySection />
                <FeaturesCarousel />
            </main>
            <Footer />
        </div>
    );
};

export default MainPage;
